export default {
      id: "icon-facebook-usage",
      viewBox: "0 0 47.995 47.707",
      url: __webpack_public_path__ + "img/icons.33fd9142.svg#icon-facebook",
      toString: function () {
        return this.url;
      }
    }